var _defs, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "edit-icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.5,
    height: 21.5,
    viewBox: "0 0 21.5 21.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #fff;\r\n        fill-rule: evenodd;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_20455",
    "data-name": "Caminho 20455",
    className: "cls-1",
    d: "M11,3.25H4A2.748,2.748,0,0,0,1.25,6V20A2.748,2.748,0,0,0,4,22.75H18A2.748,2.748,0,0,0,20.75,20V12a.75.75,0,0,0-1.5,0v8A1.25,1.25,0,0,1,18,21.25H4A1.25,1.25,0,0,1,2.75,20V6A1.25,1.25,0,0,1,4,4.75h7a.75.75,0,0,0,0-1.5Z",
    transform: "translate(-1.25 -1.25)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_20456",
    "data-name": "Caminho 20456",
    className: "cls-1",
    d: "M22.237,5.652a1.749,1.749,0,0,0,0-2.475L20.823,1.763a1.749,1.749,0,0,0-2.475,0L8.095,12.016a.752.752,0,0,0-.215.447l-.353,3.182a.75.75,0,0,0,.828.828l3.182-.353a.752.752,0,0,0,.447-.215L22.237,5.652Zm-1.06-1.061L11.11,14.658l-1.989.221.221-1.989L19.409,2.823a.252.252,0,0,1,.354,0l1.414,1.414A.252.252,0,0,1,21.177,4.591Z",
    transform: "translate(-1.25 -1.25)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_20457",
    "data-name": "Caminho 20457",
    className: "cls-1",
    d: "M16.227,4.945l2.828,2.828a.75.75,0,0,0,1.061-1.061L17.288,3.884a.75.75,0,0,0-1.061,1.061Z",
    transform: "translate(-1.25 -1.25)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.7b5d2c8a2da3bcd48ec0bd27012f9d49.svg";
export { ForwardRef as ReactComponent };